import React from "react";
import { TFunction } from "i18next";
import { toast, ToastOptions } from "react-toastify";
import { CheckboxIcon } from "@aureskonnect/react-ui";

import { DESIGNATION_PAIRS } from "./constants";

function normalizeDesignation(designation: string | string[]): string {
    return Array.isArray(designation) ? designation[0] : designation;
}

export function useSaleModeToggle(
    sortedVisibility: SaleModeVisibility[],
    setSortedVisibility: React.Dispatch<
        React.SetStateAction<SaleModeVisibility[]>
    >,
    t: TFunction
) {
    return React.useCallback(
        (item: SaleModeVisibility, _e: unknown, key: number) => {
            if (item.state) {
                toast.info(
                    t(
                        "Attention! If you want to manage loyalty by sales mode, please ensure that the authentication step in the kiosk journey is placed strictly after the sales mode selection."
                    ),
                    {
                        position: toast.POSITION.TOP_CENTER,
                        theme: "colored",
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    } as ToastOptions
                );
            }

            item.state = !item.state;
            const next = [...sortedVisibility];
            next[key].state = item.state;

            const designation = normalizeDesignation(item.designation);
            const paired = DESIGNATION_PAIRS[designation];
            if (paired) {
                const pairedIndex = next.findIndex(
                    (el: SaleModeVisibility) =>
                        normalizeDesignation(el.designation) === paired
                );
                if (pairedIndex !== -1) {
                    next[pairedIndex].state = item.state;
                }
            }

            setSortedVisibility(next);
        },
        [sortedVisibility, setSortedVisibility, t]
    );
}
